<template>
    <div>
        <canvas id="intro--confetti"></canvas>
        <div class="intro">
            <transition name="transitions__slide-from-bottom-fade">
                <div :key="slides[currentIndex].name" :class="messageClass">
                    <div class="intro__pointer"></div>
                    <div class="intro__message--content">
                        <p class="intro__message--content-title">
                            {{ $t(`pages.index.intro.${slides[currentIndex].translationProperty}.title`) }}
                        </p>
                        <p>
                            {{ $t(`pages.index.intro.${slides[currentIndex].translationProperty}.content`) }}
                        </p>
                    </div>
                    <div class="intro__steps">
                        <div v-if="currentIndex !== 0" class="intro__steps--container">
                            <div v-for="i in range" :key="i" :class="stepsClass(i)"></div>
                        </div>
                        <common-button :label="buttonLabel" type="primary" size="tiny" @click="next"></common-button>
                    </div>
                </div>
            </transition>
        </div>
    </div>
</template>
<script>
    import UsersAPI from 'api/UsersAPI'
    import { updateCurrentUser } from '~/utils'

    export default {
        data() {
            return {
                slides: [
                    // unccomment this when billing is deployed
                    // { name: 'freeTrial', classSufix: 'free-trial', translationProperty: 'free_trial' },
                    { name: 'inviteMember', classSufix: 'invite-member', translationProperty: 'invite_member' },
                    { name: 'workboard', classSufix: 'workboard', translationProperty: 'workboard' },
                    { name: 'practice', classSufix: 'practice', translationProperty: 'practice' },
                    { name: 'activatePhysician', classSufix: 'activate-physician', translationProperty: 'activate_physician' },
                    { name: 'createReferral', classSufix: 'create-referral', translationProperty: 'create_referral' },
                    { name: 'trackReferrals', classSufix: 'track-referrals', translationProperty: 'track_referrals' },
                    {
                        name: 'referralsOverviewTimeFrame',
                        classSufix: 'referrals-overview-time-frame',
                        translationProperty: 'referrals_overview_time_frame',
                    },
                ],
                currentIndex: 0,
            }
        },

        computed: {
            messageClass() {
                return { intro__message: true, [`intro__message--${this.slides[this.currentIndex].classSufix}`]: true }
            },

            range() {
                return [...Array(this.slides.length).keys()]
            },

            buttonLabel() {
                if (this.currentIndex === 0) {
                    return this.$t('common.microcopy.take_tour')
                }
                return this.currentIndex === this.slides.length - 1
                    ? this.$t('common.microcopy.done')
                    : this.$t('common.microcopy.next')
            },
        },

        methods: {
            next() {
                if (this.currentIndex === this.slides.length - 1) {
                    UsersAPI.update(this.$auth.getUser().id, { introCompleted: true })
                        .then(() => {
                            updateCurrentUser().then(() => this.$router.push({ name: 'index' }))
                        })
                        .catch(() => {})
                } else {
                    this.currentIndex += 1
                    this.scrollToElement()
                }
            },

            stepsClass(slideId) {
                return { 'intro__steps--content': true, ['intro__steps--content-active']: slideId === this.currentIndex }
            },

            scrollToElement() {
                setTimeout(() => {
                    const element = document.getElementsByClassName(
                        `intro__message--${this.slides[this.currentIndex].classSufix}`,
                    )[0]
                    window.scrollTo({
                        top: element.offsetTop - 100,
                        behavior: 'smooth',
                    })
                }, 0)
            },

            startConfetti() {
                this.$confetti.start({
                    defaultDropRate: 1,
                    defaultSize: 3,
                    particlesPerFrame: 1.5,
                    canvasId: 'intro--confetti',
                })
                setTimeout(() => {
                    this.$confetti.stop()
                }, 4000)
            },
        },

        mounted() {
            this.scrollToElement()
            this.startConfetti()
        },
    }
</script>
